import { createContext, Dispatch, SetStateAction } from 'react'

/**
 * スクロールロックの初期値
 */
export const initialScrollLockContext = false

export const ScrollLockContext = createContext<ScrollLockContextProps>([
  initialScrollLockContext,
  (): void => {
    // 初期値として空の関数を設定
  },
])

export type ScrollLockContextProps = [
  boolean,
  Dispatch<SetStateAction<boolean>>
]
